import React from "react";
import MaterialReactTable, { MaterialReactTableProps } from "material-react-table";

type RequiredProps<T extends Record<string, any>> = {
    data: MaterialReactTableProps<T>["data"];
    columns: MaterialReactTableProps<T>["columns"];
};

type DefaultTableProps<T extends Record<string, any>> = RequiredProps<T> &
    Omit<MaterialReactTableProps<T>, "data" | "columns">;

export const DefaultTable = <T extends Record<string, any>>({
    data,
    columns,
    ...rest
}: DefaultTableProps<T>) => <MaterialReactTable
        columns={columns}
        data={data
        }
        muiTableContainerProps={{
            sx: {
                "& thead tr:first-of-type th:first-of-type > div": {
                    justifyContent: "center",
                },
                "& tbody tr td:first-of-type > div": {
                    paddingLeft: 0,
                    paddingRight: 0,
                    justifyContent: "center",
                },
                "& tbody tr td:first-of-type": {
                    maxWidth: '100px',
                    textAlign: "center",
                    px: 0,
                },
                "& tbody tr:first-of-type td > p": {
                    display: "flex",
                    minWidth: "100%",
                    justifyContent: "center",
                },
                border: "1px solid #D9D9D9",
                borderRadius: "10px",
                minWidth: "100%",
                width: "100%",
                maxWidth: "100%",
                "@media (min-width: 600px)": {
                    width: "100%",
                },
                "@media (min-width: 960px)": {
                    width: "1100px",
                },
                "@media (min-width: 1280px)": {
                    width: "1100px",
                },
                "@media (min-width: 1440px)": {
                    width: "1100px",
                },
                "@media (min-width: 1680px)": {
                    width: "1300px",
                },
                "@media (min-width: 2400px)": {
                    width: "100%",
                },
            },
        }}
        muiTablePaperProps={{
            sx: {
                borderRadius: "10px",
                boxShadow: "none",
            },
        }}
        muiTopToolbarProps={{
            sx: {
                display: "none",
            },
        }}
        muiBottomToolbarProps={{
            sx: {
                display: "none",
            },
        }}
        muiTableHeadCellProps={{
            sx: {
                lineHeight: "30px",
                "& .MuiBadge-root": {
                    display: "none",
                },
            },
        }}
        muiTableHeadRowProps={{
            sx: {
                height: "45px",
                backgroundColor: "#F8FAFC",
            },
        }}
        muiTableBodyRowProps={{
            sx: {
                height: "45px",
                backgroundColor: "white",
            },
        }}
        {...rest}
    />
